import React, { FC } from 'react';

interface PanelProps {
  index: number;
  value: number;
}

const Panel: FC<PanelProps> = (props) => {
  if (props.value === props.index) {
    return <>{props.children}</>;
  }

  return null;
};

export default Panel;
